import { jsx } from "react/jsx-runtime";
import {
  getNumberMaskedValue,
  useNumberMask
} from "@elliemae/ds-form-helpers-mask-hooks";
import _ from "lodash";
import { useEffect, useState } from "react";
import { DSInputText } from "@elliemae/ds-form-input-text";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { Grid } from "@elliemae/ds-grid";
import { useFormState } from "react-hook-form";
import { useTextboxFieldUpdateLogic } from "../utils/fieldUpdateLogic";
import { useFieldAutoSetValue } from "../utils/fieldAutoSetValue";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
const Textbox = ({
  renderedField,
  schemaForm,
  rules,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  type,
  ui,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  valueHandler,
  preview,
  newRow
}) => {
  const PERCENT_VALUES = {
    allowNegative: true,
    decimalPlaces: 3,
    suffix: "%",
    includeThousandsSeparator: false
  };
  const NOT_DECIMAL_PLACES = {
    allowNegative: true,
    decimalPlaces: 0,
    prefix: "$"
  };
  const CURRENCY_WITH_CENTS = {
    allowNegative: true,
    decimalPlaces: 2,
    prefix: "$"
  };
  const NUMBER_VALUES = {
    allowNegative: false,
    includeThousandsSeparator: false
  };
  const INTEGER_LIMIT_ONE = {
    prefix: "",
    suffix: "",
    allowDecimal: true,
    decimalLimit: 2,
    integerLimit: 1
  };
  const placeholderMap = {
    "Gift Funds $": "0$",
    "Seller Concessions $": "0$",
    "Gift Funds %": "0%",
    "Seller Concessions %": "0%"
  };
  const placeholder = placeholderMap[name] || void 0;
  const textboxUpdateLogic = useTextboxFieldUpdateLogic();
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const maskOptionsMap = {
    currency: NOT_DECIMAL_PLACES,
    percent: PERCENT_VALUES,
    number: NUMBER_VALUES,
    DSCR: INTEGER_LIMIT_ONE
  };
  const centsMaskOptionsMap = {
    "property.value": CURRENCY_WITH_CENTS
  };
  const centsOpts = centsMaskOptionsMap[pathValue];
  const opts = centsOpts || maskOptionsMap[ui?.widget] || maskOptionsMap[type] || maskOptionsMap[name] || void 0;
  const getMaskedValue = (val) => {
    const sv = String(val ?? "");
    if (!opts) return sv;
    let maskValue = sv;
    if (opts.decimalPlaces === 0) {
      [maskValue] = sv.split(".");
    } else if (centsOpts && sv.includes(".")) {
      const [dollars, cents] = sv.split(".");
      maskValue = `${dollars}.${cents.padEnd(centsOpts.decimalPlaces, "0")}`;
    }
    return getNumberMaskedValue(maskValue, opts);
  };
  const [value, setValue] = useState(getMaskedValue(renderedField?.value));
  const updateDisplayValue = (val) => {
    setValue(getMaskedValue(val));
  };
  useEffect(() => {
    updateDisplayValue(renderedField?.value);
  }, [renderedField?.value]);
  useFieldAutoSetValue({
    schemaForm,
    rules,
    pathValue,
    valueHandler,
    preview,
    onAutoSet: updateDisplayValue
  });
  const inputProps = useNumberMask({
    valueSetter: setValue,
    ...opts
  });
  return /* @__PURE__ */ jsx(
    Grid,
    {
      span: ui.col_size,
      style: {
        display: isVisible ? "block" : "none",
        gridColumnStart: newRow ? 1 : void 0
      },
      children: /* @__PURE__ */ jsx(
        DSFormLayoutBlockItem,
        {
          name,
          label,
          required,
          feedbackMessage,
          hasError: !!errors[id] || !!errorMessage,
          validationMessage: errors[id]?.message?.toString() || errorMessage,
          children: /* @__PURE__ */ jsx(
            DSInputText,
            {
              ...renderedField,
              "data-testid": "textbox",
              value: opts ? value : renderedField?.value ?? "",
              ...opts ? inputProps : {},
              onChange: (e) => {
                if (opts) {
                  inputProps.onChange(e);
                  const parsedValue = e.target.value.replace(/[^0-9.-]/g, "");
                  const numericValue = parsedValue === "" ? null : parseFloat(parsedValue);
                  textboxUpdateLogic(
                    renderedField,
                    schemaForm,
                    id
                  )({
                    ...e,
                    target: { ...e.target, value: numericValue }
                  });
                } else {
                  textboxUpdateLogic(renderedField, schemaForm, id)(e);
                }
              },
              disabled: isDisabled,
              id: pathValue,
              placeholder
            }
          )
        }
      )
    }
  );
};
export {
  Textbox
};
